<div *ngIf="isVisible" class="salesforce-error">
  <div class="message">
    <svg-icon icon="alert" class="message-icon"></svg-icon>
    <p class="message-text">
      {{ ( message ?  message : 'salesforceError.defaultErrorMessage') | translate}}
    </p>
  </div>
</div>
